/**
 * Shared ListActions Component
 * Standard toolbar with filter and export buttons
 * Used by most List views in the admin panel
 */

import { FilterButton, TopToolbar, ExportButton, CreateButton, SelectColumnsButton, useListContext } from 'react-admin';
import { Button } from '@mui/material';
import FilterAltOffOutlined from '@mui/icons-material/FilterAltOffOutlined';
import { useAdminText } from './useAdminText';

interface ListActionsProps {
  hasCreate?: boolean;
  children?: React.ReactNode;
}

export function ListActions({ hasCreate = false, children }: ListActionsProps) {
  const { filterValues, setFilters } = useListContext();
  const t = useAdminText();
  const filtered = Object.values(filterValues).some(value => value !== '' && value !== undefined && value !== null);
  return (
    <TopToolbar>
      <FilterButton />
      {filtered && <Button size="small" startIcon={<FilterAltOffOutlined />} onClick={() => setFilters({}, {})}>{t('clearFilters', 'Clear filters')}</Button>}
      <SelectColumnsButton />
      {children}
      {hasCreate && <CreateButton />}
      <ExportButton />
    </TopToolbar>
  );
}
